// Dummy data & configurations for Monthly Ledger Summary Report

export const MOCK_LEDGER_ACCOUNTS = [
  { id: "110100", code: "110100", name: "HDFC Bank A/c", label: "HDFC Bank A/c", group: "Bank Accounts", type: "Asset", openingBalance: 250000.0, balanceType: "Dr" },
  { id: "110101", code: "110101", name: "SBI Current A/c", label: "SBI Current A/c", group: "Bank Accounts", type: "Asset", openingBalance: 120000.0, balanceType: "Dr" },
  { id: "110102", code: "110102", name: "ICICI Bank A/c", label: "ICICI Bank A/c", group: "Bank Accounts", type: "Asset", openingBalance: 450000.0, balanceType: "Dr" },
  { id: "110200", code: "110200", name: "Cash in Hand", label: "Cash in Hand", group: "Cash-in-Hand", type: "Asset", openingBalance: 75000.0, balanceType: "Dr" },
  { id: "210100", code: "210100", name: "ABC Suppliers", label: "ABC Suppliers", group: "Sundry Creditors", type: "Liability", openingBalance: 320000.0, balanceType: "Cr" },
  { id: "120100", code: "120100", name: "XYZ Customer", label: "XYZ Customer", group: "Sundry Debtors", type: "Asset", openingBalance: 580000.0, balanceType: "Dr" },
];

export const MOCK_MONTHLY_SUMMARY = [
  {
    month: "Apr 2026",
    monthKey: "2026-04",
    monthLabel: "Apr 2026",
    year: 2026,
    monthIndex: 3,
    debit: 1840000.0,
    credit: 1675000.0,
    openingBalance: 250000.0,
    closingBalance: 415000.0,
    balanceType: "Dr",
    note: "OPENING BAL",
  },
  {
    month: "May 2026",
    monthKey: "2026-05",
    monthLabel: "May 2026",
    year: 2026,
    monthIndex: 4,
    debit: 1250000.0,
    credit: 1285000.0,
    openingBalance: 415000.0,
    closingBalance: 380000.0,
    balanceType: "Dr",
  },
  {
    month: "Jun 2026",
    monthKey: "2026-06",
    monthLabel: "Jun 2026",
    year: 2026,
    monthIndex: 5,
    debit: 1520000.0,
    credit: 1375000.0,
    openingBalance: 380000.0,
    closingBalance: 525000.0,
    balanceType: "Dr",
  },
  {
    month: "Jul 2026",
    monthKey: "2026-07",
    monthLabel: "Jul 2026",
    year: 2026,
    monthIndex: 6,
    debit: 1480000.0,
    credit: 1560000.0,
    openingBalance: 525000.0,
    closingBalance: 445000.0,
    balanceType: "Dr",
  },
  {
    month: "Aug 2026",
    monthKey: "2026-08",
    monthLabel: "Aug 2026",
    year: 2026,
    monthIndex: 7,
    debit: 1625000.0,
    credit: 1410000.0,
    openingBalance: 445000.0,
    closingBalance: 660000.0,
    balanceType: "Dr",
    hasTransactions: true,
  },
  {
    month: "Sep 2026",
    monthKey: "2026-09",
    monthLabel: "Sep 2026",
    year: 2026,
    monthIndex: 8,
    debit: 1575000.0,
    credit: 1640000.0,
    openingBalance: 660000.0,
    closingBalance: 595000.0,
    balanceType: "Dr",
  },
  {
    month: "Oct 2026",
    monthKey: "2026-10",
    monthLabel: "Oct 2026",
    year: 2026,
    monthIndex: 9,
    debit: 1320000.0,
    credit: 1150000.0,
    openingBalance: 595000.0,
    closingBalance: 765000.0,
    balanceType: "Dr",
  },
  {
    month: "Nov 2026",
    monthKey: "2026-11",
    monthLabel: "Nov 2026",
    year: 2026,
    monthIndex: 10,
    debit: 1210000.0,
    credit: 1175000.0,
    openingBalance: 765000.0,
    closingBalance: 800000.0,
    balanceType: "Dr",
  },
  {
    month: "Dec 2026",
    monthKey: "2026-12",
    monthLabel: "Dec 2026",
    year: 2026,
    monthIndex: 11,
    debit: 1375000.0,
    credit: 1420000.0,
    openingBalance: 800000.0,
    closingBalance: 755000.0,
    balanceType: "Dr",
  },
  {
    month: "Jan 2027",
    monthKey: "2027-01",
    monthLabel: "Jan 2027",
    year: 2027,
    monthIndex: 0,
    debit: 1590000.0,
    credit: 1380000.0,
    openingBalance: 755000.0,
    closingBalance: 965000.0,
    balanceType: "Dr",
  },
  {
    month: "Feb 2027",
    monthKey: "2027-02",
    monthLabel: "Feb 2027",
    year: 2027,
    monthIndex: 1,
    debit: 1625000.0,
    credit: 1450000.0,
    openingBalance: 965000.0,
    closingBalance: 1140000.0,
    balanceType: "Dr",
  },
  {
    month: "Mar 2027",
    monthKey: "2027-03",
    monthLabel: "Mar 2027",
    year: 2027,
    monthIndex: 2,
    debit: 1910000.0,
    credit: 1645000.0,
    openingBalance: 1140000.0,
    closingBalance: 1415000.0,
    balanceType: "Dr",
  },
];

export const formatINR = (val) => {
  if (val === null || val === undefined || isNaN(val) || Number(val) === 0) return "";
  return Number(val).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
